import template from './branch.edit.html';
import controller from './branch.edit.controller';
import './branch.edit.scss';

let brancheditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default brancheditComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch/edit/branch.edit.component.js